import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner'
import { ExportService } from 'src/app/services/export.service';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import sortBy from 'sort-by';
import { Utils } from 'src/app/utils/utils';
import { MessageService } from 'primeng/api';
import { RelatorioPreCandidato } from 'src/app/models/relatorioPreCandidato.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';

interface RelatoriosCandidaturasData {
  idEleicao: number,
  token: string,
  }

@Component({
  selector: 'app-modal-relatorios-candidaturas',
  templateUrl: './modal-relatorios-candidaturas.component.html',
  styleUrls: ['./modal-relatorios-candidaturas.component.scss']
})

export class ModalRelatoriosCandidaturasComponent implements OnInit {
  title: string;
  closeBtnName: string;
  header: string;
  relatoriosCandidaturasData: RelatoriosCandidaturasData;
  onSuccess: any;
  candidatura: any;
  token: string;
  idEleicao: number;

  constructor(
    public bsModalRef: BsModalRef,
    private exportService: ExportService,
    protected candidaturaService: CandidaturaService,
    public utils: Utils,
    protected messageService: MessageService,
    protected router: Router,
    private preCandidatoService: PreCandidatosService,
  ) { }

  ngOnInit() {
    this.token = this.relatoriosCandidaturasData.token;
    this.idEleicao = this.relatoriosCandidaturasData.idEleicao;
  }

  comprovantePDF(){
    this.exportService.exportPDF('comprovante-zeresima', 'comprovante-zeresima.pdf', 'Comprovante de geração de zerésima');
  }

  gerarRelatorioCandidaturasAnalitico(){
    this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then(data => {
      this.candidatura = data;
    }).then(data => {
      this.candidaturaService.getRelatorioPreCandidatos(this.candidatura.id, this.token).then((registros: RelatorioPreCandidato[]) => {
        registros = registros.sort(sortBy('nomeCargo'));
        this.utils.exportRelatorioCandidaturaAnalitico(registros);
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso', detail: "Relatório gerado!" });        
      }).catch(err => {
        this.router.navigate(['/error-sessao']);
      });
    })
    .catch(error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não foi possível gerar o relatório de Candidaturas para esta eleição." });
    });
  }

  gerarRelatorioCandidaturasSintetico(){
    this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then(data => {
      this.candidatura = data;
      return this.preCandidatoService.getPreCandidatosByIdEleicao(this.candidatura.id, this.token);
    }).then(data => {
      this.utils.exportRelatorioCandidaturaSintetico(data);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso', detail: "Relatório gerado!" });
    })
    .catch(error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não foi possível gerar o relatório" });
    });
  }

}
